import React, { forwardRef, useState, useImperativeHandle, useRef } from 'react'
import Dialog from '@material-ui/core/Dialog'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import Label from '../../Core/InputLabel'
import Input from '../../Core/Input/Input';
// import Checkbox from '../../Core/Checkbox/Checkbox2'

const SaveModal = forwardRef((props, ref) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)
  const [form, setForm] = useState({
    name: '',
    default: false,
    favorite: false,
  })
  const [error, setError] = useState(false)

  const promissesRef = useRef({resolve: null, reject: null})

  useImperativeHandle(ref, () => ({
    show: async () => {
      return new Promise((resolve, reject) => {
        promissesRef.current = {resolve, reject}
        // setData({title, description, successButton, rejectButton})
        setOpen(true)
      })
    }
  }))

  const handleClose = (success) => {
    if (success && !form.name) {
      setError(true)
      return
    }
      
    if (promissesRef.current.resolve) {
      promissesRef.current.resolve({success: success, data: form})
    }
    setOpen(false)
  }

  const handleInputChange = (e) => {
    const { name, value, checked } = e.target
    setForm(prev => ({...prev, [name]: name === 'name' ? value : checked}))
    if (name === 'name') {
      setError(false)
    }
  }

  return (
    <Dialog onClose={() => handleClose(false)} maxWidth={'sm'} open={open}>
      <div className={styles.container}>
        <div>
          <div className={styles.title}>{ t('Save current filter') }</div>
        </div>
        <div>
          <div className={styles.formControl}>
            <Label text={t('Name')} htmlFor='name' />
            <Input
              // placeholder={`${t('Enter your company name')}...`}
              value={form.name}
              name='name'
              fullWidth
              error={error}
              onChange={handleInputChange}
            />
          </div>
          {/* <Checkbox
            onChange={handleInputChange}
            checked={form.favorite}
            label={t('Add to favorites')}
            name='favorite'
          />
          <Checkbox
            onChange={handleInputChange}
            checked={form.default}
            label={t('Make this my default filter')}
            name='default'
          /> */}
        </div>
        <div className={styles.actions}>
          <div className={styles.reject} onClick={() => handleClose(false)}>
            { t('Cancel') }
          </div>
          <div className={styles.success} onClick={() => handleClose(true)}>
            { t('Save') }
          </div>
        </div>
      </div>
    </Dialog>
  )
})

export default SaveModal

